<script>
    import {slide} from 'svelte/transition';
    export let expanderTitle ="";
    export let disabled = false;
    export let titleIcon = "";
    
    let expanded = false;
    const toggleExpanded = () => (expanded = !expanded);
</script>

 <div class="mt-4" >
    <div class="d-flex ">
        <h6 class="mb-2"><i class="fa fa-{titleIcon}"></i> {expanderTitle}</h6>
        <button on:click={() => toggleExpanded()} disabled={disabled} class="ml-auto">
            <i class="fa {expanded === true ? 'fa-chevron-up' : 'fa-chevron-down'} toggle " ></i>
        </button>
    </div>
    {#if expanded}
        <div transition:slide={{duration: 200}} class="p-6 expanded-list mt-2">
            <slot/>
        </div>
    {/if}
    <hr/>
</div>

<style>
    .toggle{
        cursor: pointer;
    }
    button{
        background: transparent;
        border: none;
        color: gray;
    }

    .expanded-list{
        max-height: 300px;
        overflow-y: auto;
        overflow-x: hidden;
    }
</style>